import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';
import { Layout } from 'antd';
const { Content } = Layout;

class ErrorPage extends Component {
  
  render() {
    return (
      <Content className={styles.content_404}>
        <div className={styles.page404}>
          <h1>404 !</h1>
          <h2>PAGE NOT FOUND</h2>
          <p>Sorry, the page you requested was not found.</p>
          <Link to=''>回首頁</Link>
        </div>
      </Content>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/views/SystemInfo/ErrorPage.js